import queryString from 'query-string';

import { USER_JOURNEY_ACCOUNT_TYPE, SESSION_URL } from '../constants';
import asyncSessionStorage from './asyncSessionStorage';

function getSessionQuerystring(name) {
  const sessionUrl = asyncSessionStorage.getItemSync(SESSION_URL);
  const parsedUrl = sessionUrl && queryString.parseUrl(sessionUrl);
  return (parsedUrl && parsedUrl.query && parsedUrl.query[name]) || '';
}

// use this instead of URLSearchParams object due to browser compatibility
function getQuerystring(name, rawUrl) {
  const url = rawUrl || window.location.href;
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`, 'i');
  const results = regex.exec(url);
  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  const value = decodeURIComponent(results[2].replace(/\+/g, ' '));
  return value;
}

function isBrokerOnboarding() {
  const inviterRole = getQuerystring('inviterRole');
  if (inviterRole && inviterRole.toLowerCase() === 'broker') {
    return true;
  }

  return false;
}

function getUserJourneyAccountType() {
  const referrerAccount = getQuerystring('referrer_account');
  if (referrerAccount === '8691268295fc53edec65e954a1db69cdf31d693a65609a147813db7421cdb7be') {
    return USER_JOURNEY_ACCOUNT_TYPE.CUSTOMER_TRADE_ACCOUNT;
  } else if (
    referrerAccount === 'c87aeed8440ac7ac6c79e24b5e4a176db3a84ae155de7501477732227764499b'
  ) {
    return USER_JOURNEY_ACCOUNT_TYPE.BUSINESS_LOANS_PAID;
  }

  const accountType = getQuerystring('account_type');
  if (accountType === 'broker') {
    return USER_JOURNEY_ACCOUNT_TYPE.BROKER;
  } else if (accountType === 'vendor') {
    return USER_JOURNEY_ACCOUNT_TYPE.MERCHANT;
  } else if (accountType === 'brokerref') {
    return USER_JOURNEY_ACCOUNT_TYPE.BROKER_REFERRED_CLIENTS;
  }

  const host = window.location.hostname;
  const isBrokerReferredClients = host.indexOf('referral-welcome') > -1 ? true : false;
  if (isBrokerReferredClients) {
    return USER_JOURNEY_ACCOUNT_TYPE.BROKER_REFERRED_CLIENTS;
  }

  const isCustomerTradeAccount = host.indexOf('shiftpayments') > -1 ? true : false;
  if (isCustomerTradeAccount) {
    const referrerAccount = getQuerystring('referrer_account');
    if (referrerAccount === '8691268295fc53edec65e954a1db69cdf31d693a65609a147813db7421cdb7be') {
      return USER_JOURNEY_ACCOUNT_TYPE.CUSTOMER_TRADE_ACCOUNT;
    }
  }

  const redirectReferrer = window.document.referrer;
  if (
    redirectReferrer &&
    (redirectReferrer.indexOf('my.shift.com') > -1 ||
      redirectReferrer.indexOf('my.getcapital.com') > -1)
  ) {
    const productType = getQuerystring('product');
    if (productType === 'EF') {
      return USER_JOURNEY_ACCOUNT_TYPE.MERCHANT_REFERRED_CUSTOMER_EF;
    }
  }

  if (redirectReferrer && redirectReferrer.indexOf('shiftpayments.com') > -1) {
    const productType = getQuerystring('product');
    if (productType === 'SP') {
      return USER_JOURNEY_ACCOUNT_TYPE.MERCHANT_REFERRED_CUSTOMER_ST;
    }
  }

  const utmSource = getQuerystring('utm_source');
  const utmMedium = getQuerystring('utm_medium');
  if (utmSource && utmMedium) {
    return utmMedium + ' ' + utmSource;
  }

  return USER_JOURNEY_ACCOUNT_TYPE.UNCLASSIFIED;
}

const urlUtils = {
  getQuerystring,
  isBrokerOnboarding,
  getUserJourneyAccountType,
  getSessionQuerystring,
};

export default urlUtils;
